import { mapState, mapActions, mapGetters } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import { partnerWorkingTime } from '@vue-storefront/core/helpers'

export const DeliveryTime = {
  name: 'DeliveryTime',
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      deliveryTime: {},
      freeShippingFrom: this.group.partner.min_free_delivery_price,
      shippingMethods: this.group.partner.shipping.methods,
      shippingMethod: this.group.partner.shipping.delivery_available ? 'delivery' : this.group.partner.shipping.pickup_available ? 'pickup' : 'clarify',
      shipping: this.$store.state.checkout.shippingDetails
    }
  },
  mounted () {
    this.$bus.$on('update-delivery-time', this.updateDeliveryTime)
    // This logic is disabled because we don't have a free shipping method at the moment, and it should be reworked
    // let isFlatrateShippingAvailable = this.group.partner.shipping.methods.find(method => method.method_code === 'delivery')
    // let isFreeshippingAvailable = this.group.partner.shipping.methods.find(method => method.method_code === 'freeshipping')
    // if (isFlatrateShippingAvailable) {
    //   this.shippingMethod = this.group.subtotal >= this.group.partner.min_free_delivery_price && isFreeshippingAvailable
    //     ? 'freeshipping'
    //     : 'delivery'
    // }
    this.shippingMethod = 'delivery'
    this.$store.state.checkout.deliveryTime = JSON.parse(localStorage.getItem('shop/checkoutFieldValues/delivery-time'));
    if (this.$store.state.checkout.deliveryTime) {
      this.deliveryTime = this.$store.state.checkout.deliveryTime.find(item => item.partner === this.group.partner.code);
      if (this.deliveryTime !== undefined) {
        if (this.deliveryTime.hasOwnProperty('shippingMethod')) {
          this.shippingMethod = this.deliveryTime.shippingMethod
        }
        this.selectedDateTime = this.deliveryTime.datetime;
      } else {
        this.deliveryTime = {}
      }
    }
  },
  computed: {
    ...mapState({
      currentUser: (state: RootState) => state.user.current
    }),
    ...mapGetters({
      cartTotals: 'cart/getTotals',
      isOpened: 'partners/isPartnerOpened',
      currentLocation: 'locations/getActiveLocation'
    }),
    isPartnerOpened () {
      return this.group.partner.open
    },
    isAsapDeliveryAllowed () {
      return this.getAsapDeliveryFromActiveLocation() && this.getAsapDeliveryFromActiveBanners()
    },
    partnerWorkingTime () {
      let workingTime = partnerWorkingTime(this.group.partner)

      return `${workingTime.workFrom.substring(0, 5)} - ${workingTime.workTo.substring(0, 5)}`
    },
    isDisable () {
      return this.deliveryTimeOption !== 'asap' && this.selectedDateTime === ''
    },
    isLastPartner () {
      return this.$store.getters['partners/getGroupedByPartnerProducts']
        .slice(-1)[0].partner.code === this.group.partner.code
    },
    getNextPartnerCode () {
      if (this.isLastPartner) {
        return false
      }
      return this.$store
        .getters['partners/getGroupedByPartnerProducts']
        [this.$store.getters['partners/getGroupedByPartnerProducts'].indexOf(this.group) + 1].partner.code
    },
    paymentMethod () {
      return this.$store.state.payment.methods
    },
    getShippingMethod () {
      let currentShippingMethod = this.shippingMethods.find(method => method.method_code === this.shippingMethod)
      if (typeof currentShippingMethod !== 'undefined' && currentShippingMethod.method_code) {
        return currentShippingMethod
      }
      return {
        method_title: 'Уточнити в оператора',
        amount: '0',
        method_code: 'clarify'
      }
    }
  },
  methods: {
    ...mapActions({
      saveDeliveryTime: 'checkout/saveDeliveryTime'
    }),
    edit () {
      if (this.isFilled) {
        this.$bus.$emit('checkout-before-edit', 'deliveryTime', this.group.partner.code)
      }
    },
    sendDataToCheckout () {
      if (!this.isDisable) {
        this.$bus.$emit(
          'checkout-after-deliveryTimeDetails',
          this.selectedDateTime,
          this.$v,
          this.deliveryTimeOption,
          this.group.partner.code,
          this.getShippingMethod,
          this.getNextPartnerCode
        )
        this.isFilled = true
      }
    },
    getAsapDeliveryFromActiveLocation () {
      return this.currentLocation.hasOwnProperty('asap_delivery') && this.currentLocation.asap_delivery == 1
    },
    getAsapDeliveryFromActiveBanners () {
      let isAsapDeliveryAllow = true
      if (this.currentLocation && this.currentLocation.hasOwnProperty('notification_banners')) {
        this.currentLocation.notification_banners.forEach(function(item) {
          if (item.asap_delivery == 0) {
            isAsapDeliveryAllow = false
          }
        })
      }
      return isAsapDeliveryAllow
    },
    updateDeliveryTime () {
      if (this.$store.state.checkout.deliveryTime) {
        let deliveryTime = this.$store.state.checkout.deliveryTime.find(item => item.partner === this.group.partner.code)
        this.deliveryTime = deliveryTime ? deliveryTime : {}
      }
      let isPickupShippingAvailable = this.group.partner.shipping.methods.find(method => method.method_code === 'pickup')
      let isFlatrateShippingAvailable = this.group.partner.shipping.methods.find(method => method.method_code === 'delivery')
      let isFreeshippingAvailable = this.group.partner.shipping.methods.find(method => method.method_code === 'freeshipping')
      if (isPickupShippingAvailable) {
        this.shippingMethod = 'pickup'
      }
      if (isFlatrateShippingAvailable) {
        // This logic is disabled because we don't have a free shipping method at the moment, and it should be reworked
        // this.shippingMethod = this.group.subtotal >= this.group.partner.min_free_delivery_price && isFreeshippingAvailable
        //   ? 'freeshipping'
        //   : 'delivery'
        this.shippingMethod = 'delivery'
      }
    }
  },
  destroyed() {
    this.$bus.$off('update-delivery-time', this.updateDeliveryTime)
  },
  watch: {
    selectedDateTime: {
      deep: true,
      handler: function () {
        this.sendDataToCheckout()
      }
    },
    deliveryTimeOption: {
      deep: true,
      handler: function () {
        this.sendDataToCheckout()
      }
    },
    getShippingMethod: {
      deep: true,
      handler: function () {
        this.sendDataToCheckout()
      }
    },
  }
}
